module.exports = __webpack_public_path__ + "static/media/rightIcon.a185df8a.svg";